module.exports = __webpack_public_path__ + "static/media/2_duplex_B_orange_square.4b5aaf6d.png";